import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import createMarkup from '../../utils/createMarkup';
// import Avatar from 'components/common/Avatar';

const Notification = ({ avatar, time, className, unread = false, flush = false, emoji, to, children }) => (
	<Link className={classNames('notification', { 'notification-unread': unread, 'notification-flush': flush }, className)} to={`${to}`}>
		{/* {avatar && (
			<div className='notification-avatar'>
				<Avatar {...avatar} className='me-3' />
			</div>
		)} */}
		<div className='notification-body'>
			<p className='mb-1'>
				{emoji ? (
					<span className='me-1' role='img' aria-hidden='true'>
						{emoji}
					</span>
				) : null}
				<span dangerouslySetInnerHTML={createMarkup(children)} />
			</p>
			{time ? <span className='notification-time'>{time}</span> : null}
		</div>
	</Link>
);

Notification.propTypes = {
	// avatar: PropTypes.shape(Avatar.propTypes),
	time: PropTypes.string,
	className: PropTypes.string,
	to: PropTypes.string,
	unread: PropTypes.bool,
	flush: PropTypes.bool,
	emoji: PropTypes.string,
	children: PropTypes.node,
};

export default Notification;
